/* oxlint-disable no-restricted-imports */
import { ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-inherit",

        "text-h1",
        "text-h2",
        "text-h3",
        "text-h4",
        "text-body1",
        "text-body2",
        "text-caption",
      ],
    },
  },
})

export const cn = (...inputs: ClassValue[]) => {
  return customTwMerge(clsx(inputs))
}

export const getCssVar = (key: string) => {
  const value = getComputedStyle(document.body).getPropertyValue(key)
  return value
}
